module.exports = __webpack_public_path__ + "static/media/photo.77e2c817.png";